export class VenueResourcesFakeDb {
  public static resources = [
    {
      uuid: "h3454hdr32738wewf",
      name: "Lorem ipsum dolor sit amet 1",
      supplier: "dummy text 1",
      listingType: "White",
    },
    {
      uuid: "ty565yrser673432rgr",
      name: "Lorem ipsum dolor sit amet 2",
      supplier: "dummy text 2",
      listingType: "Black",
    },
    {
      uuid: "gfhujty76566453dsr",
      name: "Lorem ipsum dolor sit amet 3",
      supplier: "dummy text 3",
      listingType: "Black",
    },
    {
      uuid: "w4454877675rew43",
      name: "Lorem ipsum dolor sit amet 4",
      supplier: "dummy text 4",
      listingType: "Black",
    },
    {
      uuid: "et45t467674545rtgr",
      name: "Lorem ipsum dolor sit amet 5",
      supplier: "dummy text 5",
      listingType: "White",
    },
    {
      uuid: "123456",
      user_id: "123456",
      name: "Trevino Marvel",
      email: "trevino@gmail.com",
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      },
      supplier_name: "Ketty Marvel",
      listingType: "White",
      status: 1,
      charge_rate: 25,
      rating: 4,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "4321432143214321",
      user_id: "4321432143214321",
      name: "Trevino Marvel2",
      email: "trevino2@gmail.com",
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      },
      supplier_name: "Ketty Marvel",
      listingType: "White",
      status: 2,
      charge_rate: 15,
      rating: 3,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "new-resource-001",
      user_id: "new-resource-001",
      name: "John Security Guard",
      email: "john.guard@gmail.com",
      skills: [
        {
          uuid: 'skill-3',
          name: 'Security License',
          description: 'Valid Security License'
        }
      ],
      supplier: {
        uuid: "789078",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 30,
      rating: 5,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
        {
      uuid: "new-resource-002",
      user_id: "new-resource-002",
      name: "John Security BodyGuard",
      email: "john.guard@gmail.com",
      skills: [],
      supplier: {
        uuid: "789078",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 30,
      rating: 5,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-sarah-001",
      user_id: "res-sarah-001",
      name: "Sarah Johnson",
      email: "sarah@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 20,
      rating: 4,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-mike-001",
      user_id: "res-mike-001",
      name: "Mike Chen",
      email: "mike@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 18,
      rating: 3,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-alex-001",
      user_id: "res-alex-001",
      name: "Alex Rivera",
      email: "alex@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 25,
      rating: 5,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-emma-001",
      user_id: "res-emma-001",
      name: "Emma Watson",
      email: "emma@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 22,
      rating: 4,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    // ── TEZY2-4185: Governance test resources ──
    {
      uuid: "res-gov-cancel-001",
      user_id: "res-gov-cancel-001",
      name: "Cancelled Carl",
      email: "carl@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 14,
      rating: 3,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-gov-ranp-001",
      user_id: "res-gov-ranp-001",
      name: "RANP Rachel",
      email: "rachel@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 15,
      rating: 4,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-gov-draft-001",
      user_id: "res-gov-draft-001",
      name: "Draft Dave",
      email: "dave@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 12,
      rating: 3,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    {
      uuid: "res-gov-past-001",
      user_id: "res-gov-past-001",
      name: "Past Pete",
      email: "pete@mail.com",
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      },
      supplier_name: "Jack Allon",
      listingType: "White",
      status: 1,
      charge_rate: 13,
      rating: 3,
      venue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    }
  ];
}
